<template>
	<div>
		<slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
			<div class="single container-max page-content">
				<div class="row position-relative">

					<div class="col-12 col-md-6">
						<slot name="image-carousel"></slot>
					</div>

					<div class="col-12 col-md-6 mt-3 mt-md-0">
						<div>
						<!-- START SINGLEITEM_DETAILS -->
							<h1 class="h2 title mb-4"><span>{{ currentVariation | itemName }}</span></h1>

							<p class="single-description" v-if="isShortDescriptionActive && currentVariation.texts.shortDescription !== ''" v-html="currentVariation.texts.shortDescription"></p>

							<div class="mb-5">
								<span class="articlenumber small d-block">
									<b>{{ $translate("Ceres::Template.singleItemNumber") }} </b>
									<span>{{ currentVariation.variation.number }}</span>
								</span>
								<span class="articlenumber small d-block" v-if="currentVariation.filter.hasManufacturer">
									<b> {{ $translate("Ceres::Template.singleItemManufacturer") }} </b>
									<span> {{ currentVariation.item.manufacturer.externalName }}</span>
								</span>
								<span class="articlenumber small d-block" v-if="currentVariation.unit" :class="{ 'is-single-piece': currentVariation.unit && currentVariation.unit.content === 1 && currentVariation.unit.unitOfMeasurement === 'C62' }">
									<b> {{ $translate("Ceres::Template.singleItemContent") }}</b>
									<span>{{ currentVariation.unit.content | numberFormat }} </span>
									<span>{{ currentVariation.unit.names.name }}</span>
								</span>
								<span v-if="currentVariation.variation.mayShowUnitPrice" class="articlenumber small d-block">
									<b>{{ $translate("Ceres::Template.singleItemUnitPrice") }}</b>
									<span class="base-price-value">{{ variationGraduatedPrice.basePrice | specialOffer(currentVariation.prices, "basePrice") }}</span>
								</span>

								<img :src="currentVariation.item.manufacturer.logo" :alt="currentVariation.item.manufacturer.externalName" class="img-fluid d-block mt-3 manufacturerlogo" v-if="currentVariation.item.manufacturer.logo">
							</div>


							<!-- Variation -->
							<div class="mb-3" v-if="attributes.length || Object.keys(units).length">
								<variation-select></variation-select>
							</div>
							<!-- /Variation -->

							<!-- Item Bundle -->
								<item-bundle v-if="currentVariation.variation.bundleType === 'bundle'" :bundle-type="currentVariation.variation.bundleType" :bundle-components="currentVariation.bundleComponents"></item-bundle>
							<!-- /Item Bundle -->

							<slot name="before-price"></slot>

							<div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
								<order-property-list></order-property-list>
							</div>

							<graduated-prices></graduated-prices>

							<item-price :show-cross-price="isRecommendedPriceActive"></item-price>

							<slot name="after-price"></slot>

							<item-availability></item-availability>

							<div class="mb-3 singleadd">
								<div class="w-100">
									<slot name="before-add-to-basket"></slot>
								</div>

								<div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
									{{ $translate("Ceres::Template.singleItemSetInfo") }}
								</div>
								<div v-else class="col-12 col-sm-7 col-md-12 col-lg-8 my-3">
									<add-to-basket
									:variation-id="currentVariation.variation.id"
									:is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
									:has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
									:interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
									:minimum-quantity="currentVariation.variation.minimumOrderQuantity"
									:maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
									:order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
									:use-large-scale="false"
									:show-quantity="true"
									:item-url="currentVariation | itemURL"
									:is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
									:has-price="currentVariation | hasItemDefaultPrice"
									>
									</add-to-basket>
								</div>

								<div class="w-100">
									<slot name="after-add-to-basket"></slot>
								</div>
							</div>

							<div v-if="isWishListEnabled" class="row">
								<div class="col-12 wishlist mb-5">
									<add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
								</div>
							</div>
							<!-- ./ITEM DETAIL -->

							<slot name="additional-content-after-add-to-basket"></slot>

							<slot name="additional-content-after-vat"></slot>
							<!-- END SINGLEITEM_DETAILS -->

							<div class="download-wrapper d-flex">
								<template v-for="(property) in currentVariation.variationProperties" v-if="currentVariation.variationProperties">
									<template v-for="(property, index) in property.properties" v-if="property.id == 16 || property.id == 25">
										<a :href="property.values.value | propertyFileUrl" target="_blank" class="d-block mr-3 mt-3">
											<img src="https://cdn02.plentymarkets.com/gw81lpaq889b/frontend/webshop/images/static/icons/2021/pdficon.svg" :alt="property.names.name" class="img-fluid d-block mx-auto mb-2">
											<span class="color-dark small font-weight-bold">{{ property.names.name }}</span>
										</a>
									</template>
								</template>
							</div>

							<div class="properties-wrapper d-flex">
								<template v-for="(property) in currentVariation.variationProperties" v-if="currentVariation.variationProperties">
									<template v-for="(property, index) in property.properties" v-if="property.id == 26">
										<template v-if="property.values.length > 0">
											<template v-for="(property, index) in property.values">
												<img  :src="property.description" :alt="property.value" class="img-fluid mr-3 mt-3">
											</template>
										</template>
										<template v-else>
											<img  :src="property.values.description" :alt="property.values.value" class="img-fluid mr-3 mt-3">
										</template>
									</template>
								</template>
							</div>
						</div>
					</div>

					<div class="col-12">
					<!-- ITEM DESCRIPTION -->
						<div class="my-5">
							<ul class="nav nav-tabs" role="tablist">
								<li class="nav-item" v-if="isDescriptionTabActive">
									<a class="nav-link active" data-toggle="tab" :href="'#details-' + currentVariation.variation.id" role="tab">{{ $translate("Ceres::Template.singleItemDescription") }}</a>
								</li>
								<li class="nav-item" v-if="isTechnicalDataTabActive">
									<a :class="{ 'active': !isDescriptionTabActive && isTechnicalDataTabActive }" class="nav-link" data-toggle="tab" :href="'#data-' + currentVariation.variation.id" role="tab">{{ $translate("Ceres::Template.singleItemTechnicalData") }}</a>
								</li>

								<slot name="add-detail-tabs"></slot>
							</ul>

							<div class="tab-content overflow-hidden">
								<div class="tab-pane active overflow-auto" :id="'details-' + currentVariation.variation.id" role="tabpanel" v-if="isDescriptionTabActive">
									<div class="my-4" v-html="currentVariation.texts.description"></div>
								</div>
								<div :class="{ 'active': !isDescriptionTabActive && isTechnicalDataTabActive }" class="tab-pane overflow-auto" :id="'data-' + currentVariation.variation.id" role="tabpanel" v-if="isTechnicalDataTabActive">
									<div class="my-4" v-html="currentVariation.texts.technicalData"></div>
								</div>
								<slot name="add-detail-tabs-content"></slot>
							</div>
						</div>
					<!-- ./ITEM DESCRIPTION -->
					</div>
				</div>

				<div class="mb-5">
					<slot name="item-list-container"></slot>
				</div>
				<slot name="feedback-container"></slot>
			</div>
		</slot>
	</div>
</template>

<script>
import { get } from "../../helper/get";
import { isNullOrUndefined } from "../../helper/utils";

export default {

    name: "single-item",

    props: {
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false
        },
        showNetPrices: {
            type: Boolean,
            default: false
        },
        isWishListEnabled: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
            required: true
        },
        afterKey: Object
    },

    provide()
    {
        return {
            itemId: this.$props.itemId
        }
    },

    jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
    ],

    computed:
    {
        itemConfig()
        {
            return App.config.item.itemData;
        },

	 variationGraduatedPrice() {
            return this.$store.getters[`${this.itemId}/variationGraduatedPrice`];
        },

        isDescriptionTabActive()
        {
            return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.description.length;
        },

        isRecommendedPriceActive()
        {
            return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
        },

        isShortDescriptionActive()
        {
            return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
        },

        hasShippingCostsCategoryId()
        {
            return App.config.global.shippingCostsCategoryId > 0;
        },

        isTechnicalDataTabActive()
        {
            return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.technicalData.length;
        },

        variationGroupedProperties()
        {
            return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },

        variationMissingProperties()
        {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        currentVariation() {
            return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
        },

        isVariationSelected() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
        },

        attributes() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
        },

        units() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
        }
    },

    created()
    {
        this.$store.dispatch("initVariation", this.itemData);
        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
        this.$store.dispatch("addLastSeenItem", this.currentVariation.variation.id);

        this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
            itemId:             this.itemId,
            attributes:         this.attributesData,
            variations:         this.variations,
            initialVariationId: this.currentVariation.variation.id,
            isPleaseSelectOption: this.initPleaseSelectOption,
            afterKey:           this.afterKey
        });
    },

    methods:
    {
        getDataField(field)
        {
            return get(this.currentVariation, field);
        },

        getFilteredDataField(field, filter)
        {
            if (!isNullOrUndefined(this.$options.filters[filter]))
            {
                return this.$options.filters[filter](this.getDataField(field));
            }

            return this.getDataField(field);
        }
    }
}
</script>
